import { Vector3 } from 'three';
import ObjectView from '@scene/views/object-view';
import Axis from '@scene/axis';

export const CameraOrientations = {
  Z_TOP: {
    perspectiveCamera: {
      position: new Vector3(800, 950, 380)
    }
  },
  Y_TOP: {
    perspectiveCamera: {
      position: new Vector3(700, 350, 600)
    }
  },
  Z_BOTTOM: {
    perspectiveCamera: {
      position: new Vector3(700, -100, 300)
    }
  }
};

export default {
  mode: ObjectView.mode.MODE_3D,
  orthographicCamera: {
    position: new Vector3(0.0007121568184116151, 712.1446482277966, -0.000005268009116589875),
    zoom: 10
  },
  perspectiveCamera: {
    position: CameraOrientations.Z_TOP.perspectiveCamera.position,
    target: new Vector3(9.54352148150695, -25, 32.633554557162206),
    zoom: 1
  },
  axis: {
    position: null,
    orientation3D: Axis.types.Z_TOP,
    orientation2D: Axis.types.Y_TOP_2D
  }
};



// WEBPACK FOOTER //
// ./src/reducers/camera/defaults/generalCalculation.js